import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import { useHistory } from 'react-router-dom';

import { FlyInTransition } from '../../components/transitions/transitions';
import styled from 'styled-components';

const queryImage =
  'https://visit-public-stage.s3.ap-south-1.amazonaws.com/query_raise.png';
const uploadImage =
  'https://visit-public-stage.s3.ap-south-1.amazonaws.com/upload_icon.png';
const PrescriptionText = styled.h1`
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  @media (max-width: 400px) {
    font-size: 12px;
  }
  @media (max-width: 360px) {
    font-size: 11px;
  }
`;
const DoctorText = styled.p`
  color: #fff;
  text-align: center;
  font-size: 12px;
  @media (max-width: 400px) {
    font-size: 10px;
  }
`;
function SnackBar({ data, showModal, closeModal }) {
  const history = useHistory();

  const handleNavigation = () => {
    history.push('/consultation/appointment/appointment-status', {
      requestId: data.pendingRequestId,
      goBack: true,
      blockers: data,
    });
  };
  const isRejected = data && data.prescriptionVerificationStatus === 'rejected';
  const gradientColor = isRejected
    ? 'linear-gradient(to right, #FD2E2E, #FF8989)'
    : 'linear-gradient(to right, #ffbb00, #A28BFF)';
  const prescriptionIcon = isRejected ? queryImage : uploadImage;
  const clinicText = isRejected ? 'In-Clinic' : 'Offline';
  const uploadButtonText = isRejected ? '#E02323' : '#ffbb00';
  const prescriptionText = isRejected
    ? 'Prescription Query'
    : 'Upload Prescription';

  return (
    <div>
      <FlyInTransition in={showModal} mountOnEnter unmountOnExit appear>
        <div>
          <Carousel
            showArrows={true}
            swipeable
            showThumbs={false}
            className="z-40 rounded-t-12 fixed bottom-0 w-full bg-textbox"
            showStatus={false}
          >
            <div
              className="flex items-center text-txtlight justify-between rounded-t-12 h-60px"
              style={{
                backgroundImage: gradientColor,
                boxShadow: '0px -5px 5px rgba(0,0,0,0.1) inset',
                padding: '10px',
              }}
            >
              <div className="flex w-full items-center">
                <div className="bg-textbox rounded-full w-60px flex justify-center mt-[-10px] h-[52px] max-h-[60px]">
                  <img
                    src={prescriptionIcon}
                    style={{ height: '52px', width: '52px' }}
                    alt="prescription"
                  />
                </div>
                <div className="flex justify-between w-full px-1 items-center">
                  <div className="flex flex-col justify-start items-center border-r pr-16px">
                    <PrescriptionText>{prescriptionText}</PrescriptionText>
                    <DoctorText>
                      {clinicText} | {data.doctorName}
                    </DoctorText>
                  </div>
                  <div className="pt-8 px-8 flex justify-center items-center">
                    <button
                      className="text-txtlight rounded-8 w-100px h-24px text-body-l font-semibold"
                      style={{
                        background: 'linear-gradient(180deg, #FFFFFF, #E4E4E4)',
                        fontWeight: '600',
                        color: uploadButtonText,
                      }}
                      onClick={handleNavigation}
                    >
                      Upload
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Carousel>
        </div>
      </FlyInTransition>
    </div>
  );
}

export default SnackBar;
